 /**
 * @Author:
 * @Description:
 * @DateTime: Created in 08:56 2019-07-10
 */

 import { defaultNullValue } from 'src/config';
 import Api from 'src/util/api';
 import { PageDo, Result, ResultPageDo, Integer } from 'src/types/base';
 
export declare namespace AuthLogConfigDOI {
     export interface RowDataI {
         mn: string;
         sim: string;
         id: number;
         datetime: string;
         file_name: string;
         is_auth: Integer;
     }
 
     export interface QueryRowDataParamsI extends PageDo {
     }
}


export default class AuthLogConfigApi {
     /**
      * 查询列表
      * @param {GetPeopleManageListParamsI} params
      * @returns {Promise<ResultPageDo<PeopleManageRowI[]>>}
      */
     static async searchList(params: AuthLogConfigDOI.QueryRowDataParamsI): Promise<ResultPageDo<AuthLogConfigDOI.RowDataI[]>> {
         return Api.post('/monitor/select/auth/log', {
            ...params,
         });
     }
 }
 